// extracted by mini-css-extract-plugin
export default {"root":"zyONZ6","link":"w28ffY","text":"QRZUSe","logo":"KNyq2R"};